import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { Package } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function BeautyClinicsPackagesPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Pacotes"
      description="Gerencie os pacotes de procedimentos da clínica."
      icon={Package}
    />
  
    </MainLayout>);
}

